var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"looping-rhombuses-spinner",style:(_vm.spinnerStyle)},_vm._l((_vm.rhombusesStyles),function(rs,index){return _c('div',{staticClass:"rhombus",style:(rs),attrs:{"ikey":index}})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }